import { FC } from "react"

interface ILight {}

export const Light: FC<ILight> = () => {
  return (
    <svg
      width="27"
      height="30"
      viewBox="0 0 27 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" filter="url(#filter0_f_905_42547)">
        <path d="M12.1954 5.25H13.9789L21.75 24.2701L5.125 24.5L12.1954 5.25Z" />
      </g>
      <defs>
        <filter
          id="filter0_f_905_42547"
          x="0.125"
          y="0.25"
          width="26.625"
          height="29.25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.5"
            result="effect1_foregroundBlur_905_42547"
          />
        </filter>
      </defs>
    </svg>
  )
}
